import {XauditModel} from '../../xaudit.model';
import {TdoUserGroupRoleConfigurationModel} from './tdo-user-group-role-configuration.model';

export class TdoUserRoleConfigurationModel extends XauditModel {
  RoleId: string;
  RoleName: string;
  Description: string;

  cfgTDOUserGroupRoles: TdoUserGroupRoleConfigurationModel[];
}
